import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/voucher-applications.js';
import q from '../query.js';
export const voucherApplicationsEntity = 'voucher-applications';
const voucherApplicationsKey = `voucher-applications`;
export const useVoucherApplications = () => q.query(voucherApplicationsKey, () => api.getAll(), keys.read.collection(voucherApplicationsEntity));
//# sourceMappingURL=index.js.map